import request from '../utils'

const forecastApi = {
    forecastList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/forecast`)
        const res = await req;
        return res.body;
    }, 
    forecastDetail: async (modelingId, forecast) => {
        const req = request.get(`/api/modeling/${modelingId}/forecast/${forecast}`)
        const res = await req;
        return res.body;
    },
    forecastUpdate: async (modelingId, forecast) => {
        const req = request.put(`/api/modeling/${modelingId}/forecast/${forecast.id}`).send(forecast);
        const res = await req;
        return res.body;
    },
    forecastCreate: async (modelingId, forecast) => {
        const req = request.post(`/api/modeling/${modelingId}/forecast`).send(forecast);
        const res = await req;
        return res.body;
    },
    forecastDelete: async (modelingId, forecastId) => {
        const req = request.delete(`/api/modeling/${modelingId}/forecast/${forecastId}`);
        await req;
    },
    forecastCopy: async (modelingId, forecastId) => {
        const req = request.get(`/api/modeling/${modelingId}/forecast/${forecastId}/copy`)
        const res = await req;
        return res.body;
    }, 
};

export default forecastApi